import React from 'react';
import Logo from '../components/Logo';
import Navigation from '../components/Navigation';

const About = () => {
    return (
        <div>
            <Logo />
            <Navigation />
            <div className='about-container'>
                <p>
                    <h3>Voici un site React sur lequel j'ai utilisé :</h3><br />
                    - axios pour le fetch<br />
                    - Je fais appelle à une API pour afficher des informations, elles peuvent être triées en fonction de l'espèce ou bien par une recherche.<br />
                    (il y a un bug que je n'ai pas encore réussi à regler, quant à la recherche en fonction des lettres saisies).<br />
                    - Je suis en train de voir comment mettre une image par lorsqu'il y a une source d'image qui est 404, je pense à onerror ou une ternaire mais ... c'est en cours.<br />
                    - sass<br />
                    - chaque semaine je vais produire un nouveau site utilisant des possibilités différentes avec React et Node.<br />
                    Maël
                </p>
            </div>
        </div>
    );
};

export default About;